import styled from 'styled-components';
import MuiTableFooter from '@mui/material/TableFooter';

export const TableFooter = styled(MuiTableFooter)``;
